import styled from 'styled-components';
import type { PtoVolumePosition } from '@shared/api';
import { rowGapCount, type GapRowFlags } from '../rdGaps/logic';

/** «⚠» в текстовом начертании (U+FE0E): цвет задаёт CSS, а не цветной эмодзи
 *  шрифта (как у значка расхождения шифра в «Разделе»). */
const WARN_SIGN = '⚠︎';

/** `font-feature-settings: normal`: со стилистическими наборами GlobalStyle
 *  запасной шрифт Windows рисует «⚠» залитым прямоугольником. */
const Badge = styled.button`
  margin-left: ${({ theme }) => theme.spacing(1.5)};
  padding: 0 6px;
  font: inherit;
  font-size: 11px;
  font-weight: 600;
  font-feature-settings: normal;
  line-height: 18px;
  white-space: nowrap;
  border-radius: ${({ theme }) => theme.radius.pill};
  border: 1px solid ${({ theme }) => theme.colors.status.warning};
  color: ${({ theme }) => theme.colors.status.warning};
  background: transparent;
  cursor: pointer;

  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadow.focus};
  }
`;

interface Props {
  position: PtoVolumePosition;
  /** Значки анализа комплектности; null — анализ выключен для проекта или роли. */
  gaps: GapRowFlags | null;
}

/** Значок «⚠ N» у строки ВОР: N находок анализа комплектности (№7) по этой
 *  работе — чего, возможно, не хватает в РД. Клик открывает вкладку «Анализ
 *  комплектности» с находками только этой строки. У прочих строк и без
 *  находок — ничего. */
export function GapBadge({ position, gaps }: Props) {
  const n = rowGapCount(position, gaps?.flags);
  if (!gaps || n === 0) return null;
  return (
    <Badge
      type="button"
      title="Возможно не учтено в РД по этой работе — открыть анализ комплектности"
      aria-label={`Анализ комплектности: находок по строке — ${n}`}
      onClick={() => gaps.onOpen(position.record_uid)}
    >
      {WARN_SIGN} {n}
    </Badge>
  );
}
